import { BaseObject } from "../../../../shared/baseObject";
import { RequestViews } from "./requestViews";

export abstract class BaseRequest extends BaseObject {
  
  client: RequestViews;
  extraArgs?: Map<string, string>;
}